module.exports = __webpack_public_path__ + "img/join-7.8f3b82e7.png";